export const FORM_FIELD_SCROLL_MARGIN_TOP = 88 // keep synced with --form-field-scroll-margin-top

/**
 * @param item - as in "validable element", which can be a fieldset or an input
 * @return Returns the top node for the field, which generally is a div including the label, the div, and the error message
 * Please read the special cases in the implementation itself (in English would not be much more concise)
 */
export const getFieldNode = item => {
  if (item.tagName === 'FIELDSET') {
    return item
  }
  if (item.type === 'radio' || item.type === 'checkbox') {
    return item.closest('.cmp-form-options')
  }
  if (item.getAttribute('data-input-type') === 'tel' || item.type === 'tel') {
    return item.closest('.cmp-form-text')
  }
  if (item.getAttribute('name') === 'stateCode' || item.getAttribute('name') === 'countryCode' || item.getAttribute('name') === 'industry' || item.getAttribute('name') === 'refererInquiryConcerns') {
    return item.closest('.cmp-form-options')
  }
  return item.parentNode
}

export const getFieldLabel = fieldNode => {
  if (fieldNode.tagName === 'FIELDSET') {
    return fieldNode.querySelector('legend')?.innerText || fieldNode.innerText
  }
  return fieldNode.querySelector('label')?.textContent || fieldNode.querySelector('label')?.innerText || fieldNode.innerText
}

export const afterSmoothScroll = callback => {
  // No precise and maintainable way to detect smooth scroll duration has been identified as of July 2022. We assume 500 ms.
  setTimeout(callback, 500)
}
